import React from "react";
import { renderPrice } from "../../../../Panel/Common/Function";
import { useCard } from "../Hooks";
import InSetBoxShadow from "../../../Common/InSetBoxShadow";
import { useSelector } from "react-redux";
import {
  GenderRender,
  RenderPrice,
  ToDateJalali,
} from "../../../Common/Function";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { Color } from "../../../../Utils/styles";

const Peyment = ({ kind, setKind }) => {
  const {
    storeReserve,
    checkOffer,
    code,
    setCode,
    totalPrice,

    loading,
  } = useCard();
  const { basket } = useSelector(state => state);
  const typePay = [
    {
      label: "آنلاين",
      id: "gateway",
      text: "پرداخت آنلاین",
    },
    {
      label: "کیف پول",
      id: "wallet",
      text: "پرداخت کیف پول",
    },
  ];
  const renderState = () => {
    if (loading.reserve) {
      return "در حال پردازش";
    } else {
      if (kind == "wallet") {
        return "پرداخت با کیف پول";
      }
    }
    return "پرداخت آنلاین";
  };
  const renderStateTime = time => {
    if (time.status == "ok") {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiFillCheckCircle color={Color.greenLight} />
          <h6
            style={{
              fontSize: "12px",
              fontSize: "11px",
              fontWeight: "400",
              marginRight: "5px",
            }}
          >
            آماده رزرو
          </h6>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiFillCloseCircle color={Color.primary} />
          <h6
            style={{
              fontSize: "12px",
              fontSize: "11px",
              fontWeight: "400",
              marginRight: "5px",
            }}
          >
            ظرفیت پر
          </h6>
        </div>
      );
    }
  };
  const renderComponent = () => {
    if (basket.type && basket.type == "contract") {
      return (
        <div className="col-12">
          <InSetBoxShadow className="order-card">
            <div className="row" style={{ overflow: "hidden" }}>
              <div className="col-md-5" style={{}}>
                <img
                  className="order-card-img"
                  style={{ height: "213px" }}
                  src={basket.item.image}
                />
              </div>
              <div className="col-md-7 px-4 px-md-2 ">
                <h6
                  className="h3 mb-3 mt-2 mt-sm-3"
                  style={{
                    fontWeight: "400",
                  }}
                >
                  {basket.item.name}
                </h6>
                <div
                  className="my-4"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {basket.times.map(time => {
                    if (time.status == "ok") {
                      return (
                        <div
                          style={{
                            border: "1px solid #eee",
                            borderRadius: "5px",
                            padding: "10px 15px",
                            margin: "0 0 8px 8px",
                          }}
                        >
                          <h6
                            style={{
                              fontWeight: "400",
                              textAlign: "center",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >{`${time.start} تا ${time.end}`}</h6>
                          <h6
                            style={{
                              fontWeight: "400",
                              textAlign: "center",
                              fontSize: "12px",
                              marginTop: "5px",
                              fontWeight: "400",
                            }}
                          >
                            {`${ToDateJalali(time.date)}`}
                          </h6>
                          <h6
                            style={{
                              fontWeight: "400",
                              textAlign: "center",
                              fontSize: "12px",
                              marginTop: "5px",
                              fontWeight: "400",
                            }}
                          >
                            {`${RenderPrice({ price: time.price })}`}
                          </h6>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "10px",
                              fontWeight: "400",
                            }}
                          >
                            {renderStateTime(time)}
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </InSetBoxShadow>
        </div>
      );
    } else {
      return (
        <div className="col-12">
          <InSetBoxShadow className="order-card">
            <div className="row" style={{ overflow: "hidden" }}>
              <div className="col-md-5" style={{}}>
                <img className="order-card-img" src={basket.item.image} />
              </div>
              <div className="col-md-7 px-4 px-md-2 ">
                <h4
                  className="h3 mb-3 mt-2 mt-sm-3"
                  style={{
                    fontWeight: "400",
                  }}
                >
                  {basket.item.name}
                </h4>
                {basket.type && basket.type == "contract" ? (
                  <div
                    className="my-4"
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {basket.times.map(time => {
                      return (
                        <div
                          style={{
                            border: "1px solid #eee",
                            borderRadius: "5px",
                            padding: "10px 15px",
                            margin: "0 8px 8px 8px",
                          }}
                        >
                          <h6
                            style={{
                              fontWeight: "400",
                              textAlign: "center",
                              fontSize: "14px",
                            }}
                          >{`${time.start} تا ${time.end}`}</h6>
                          <h6
                            style={{
                              fontWeight: "400",
                              textAlign: "center",
                              fontSize: "12px",
                              marginTop: "5px",
                            }}
                          >
                            {`${ToDateJalali(time.date)}`}
                          </h6>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "10px",
                            }}
                          >
                            {renderStateTime(time)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <>
                    <div className="row px-0">
                      {basket.time.title && (
                        <div
                          className="col-12 col-xl-5 d-flex"
                          style={{ borderLeft: "1px solid #eee" }}
                        >
                          <h6
                            className="small"
                            style={{
                              color: "#404040",
                              margin: "0",
                              fontWeight: "400",
                            }}
                          >
                            <img
                              className="order-card-icon"
                              src={
                                window.origin +
                                `/WebSide/assets/images/damble.png`
                              }
                              alt="همه ملاقات"
                            />
                            {basket.time.title}
                          </h6>
                        </div>
                      )}
                      <div
                        className="col-12 col-lg-6 col-xl-4 my-3 my-xl-0"
                        style={{ borderLeft: "1px solid #eee" }}
                      >
                        <h6
                          style={{
                            margin: "0",
                            fontSize: "13px",
                            fontWeight: "400",
                          }}
                        >
                          <img
                            className="order-card-icon"
                            src={
                              window.origin + `/WebSide/assets/images/404.png`
                            }
                            alt="همه ملاقات"
                          />
                          {`${basket.time.start} الی ${basket.time.end}`}
                        </h6>
                      </div>{" "}
                      {basket.time.gender && (
                        <div
                          className="col-12 col-lg-6 col-xl-3 d-flex align-items-center"
                          style={{
                            color: "#404040",
                          }}
                        >
                          <h6
                            className=""
                            style={{
                              margin: "0",
                              fontWeight: "400",
                            }}
                          >
                            {`ویژه ${GenderRender(basket.time.gender)}`}
                          </h6>
                        </div>
                      )}
                      <div className="col-12 mt-3 mb-2">
                        <div className="d-flex align-items-center">
                          <img
                            className="order-card-icon"
                            src={
                              window.origin +
                              `/WebSide/assets/images/counter.png`
                            }
                            alt="همه مقالات"
                          />
                          <button className="counter-btn">-</button>
                          <div className="count-box">{basket.count}</div>
                          <button className="counter-btn">+</button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </InSetBoxShadow>
        </div>
      );
    }
  };
  return (
    <div className="row payment-step">
      <div className="col-12">
        <InSetBoxShadow className={"py-2 py-md-4 px-2 px-md-2"}>
          <div className="row">
            <div className="col">
              <h3
                className="py-2 mb-4"
                style={{
                  borderBottom: "0.5px solid #eee",
                  fontWeight: "400",
                }}
              >
                سبد خرید
              </h3>
            </div>
          </div>
          <div className="row px-lg-0">
            <div className="col-lg-8">
              <div className="row">
                <div className="col-12">
                  <h6
                    className="mb-2 mb-md-3 ps-2 title-2"
                    style={{
                      fontWeight: "400",
                    }}
                  >
                    <img
                      src={window.origin + `/WebSide/assets/images/49.png`}
                      alt="همه ملاقات"
                    />
                    سفارشات شما
                  </h6>
                </div>
                {renderComponent()}
              </div>
              <div className="row mt-2 py-4 px-lg-0">
                <div className="col-12">
                  <h6
                    className="title-2 mb-2 mb-md-3 ps-2"
                    style={{
                      fontWeight: "400",
                    }}
                  >
                    <img
                      src={window.origin + `/WebSide/assets/images/50.png`}
                      alt="همه ملاقات"
                    />
                    اطلاعات هویتی
                  </h6>
                </div>

                {basket.otherpeopel.map(user => {
                  return (
                    <div className="col-12 mb-2" key={user.mobile}>
                      <InSetBoxShadow className={"p-2"}>
                        <h6
                          style={{
                            fontWeight: "400",
                          }}
                        >
                          {user.fullname}
                        </h6>
                        <h6
                          style={{
                            fontWeight: "400",
                          }}
                        >
                          {user.mobile}
                        </h6>
                        <h6
                          style={{
                            fontWeight: "400",
                          }}
                        >
                          {user.national_code}
                        </h6>
                      </InSetBoxShadow>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-lg-4 mt-2 mt-md-0">
              <div className="row">
                <div className="col-12">
                  <h6
                    className="mb-2 mb-md-3 ps-2 title-2"
                    style={{
                      fontWeight: "400",
                    }}
                  >
                    <img
                      src={window.origin + `/WebSide/assets/images/f.png`}
                      alt="همه ملاقات"
                    />
                    فاکتور شما{" "}
                  </h6>
                </div>
              </div>
              <div className="p-2 factor-card">
                {basket.offer && basket.offer.status && (
                  <div className="d-flex justify-content-between flex-lg-column flex-xl-row align-items-xl-center  my-2 mb-lg-3 mt-xl-2 mb-xl-4">
                    <h6 className="small">تخفیف : </h6>
                    <h6 className="text-end">
                      {renderPrice(basket.offer.new_discount)}
                    </h6>
                  </div>
                )}

                <div className="d-flex justify-content-between flex-lg-column flex-xl-row align-items-xl-center  my-2 mb-lg-3 mt-xl-2 mb-xl-4">
                  <h6 className="small mb-2">مبلغ قابل پرداخت : </h6>
                  {basket.type && basket.type == "contract" ? (
                    <h6 className="text-end">
                      {renderPrice(basket.total_price)}
                    </h6>
                  ) : (
                    <h6 className="text-end">{renderPrice(totalPrice())}</h6>
                  )}
                </div>
                <div className="d-flex justify-content-between flex-lg-column  align-items-center align-items-lg-start">
                  <h6 className="small text-start mb-2 "
                    style={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    کد تخفیف :
                  </h6>
                  <div
                    className="off-input mb-2"
                    style={{ marginRight: "20px" }}
                  >
                    <input
                      onChange={({ target: { value } }) => {
                        setCode(value);
                      }}
                    />
                    <button
                      onClick={() => {
                        checkOffer(code);
                      }}
                    >
                      اعمال
                      <br />
                      <span className="d-lg-none d-xl-inline"> کد تخفیف</span>
                    </button>
                  </div>
                </div>
                <div className="mb-2 d-flex flex-wrap justify-content-center aling-items-center mt-2">
                  {typePay &&
                    typePay.map((element, coutn) => (
                      <button
                        key={coutn}
                        className="btn  btn-dark"
                        style={{
                          border: "none",
                          fontSize: "0.95rem",
                          marginLeft: "0.9rem",
                          backgroundColor: element.id != kind && "white",
                          color: element.id != kind && "black",
                        }}
                        onClick={() => {
                          setKind(element.id);
                        }}
                      >
                        {element.label}
                      </button>
                    ))}
                </div>
                <div className="mb-2 d-flex justify-content-center align-items-center mb-3 mb-xl-2 mt-2 mt-lg-2">
                  <button
                    style={{
                      border: "none",
                      borderRadius: "0.5rem",
                      backgroundColor: "#fff",
                      padding: "10px 0",
                    }}
                    className="w-100"
                    onClick={() => storeReserve(kind)}
                    disabled={loading.reserve}
                  >
                    {renderState()}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-2 mt-4">
            <div className="col">
              <p
                style={{
                  fontWeight: "400",
                }}
              >
                <img
                  src={window.origin + `/WebSide/assets/images/danger.png`}
                  alt="همه ملاقات"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginLeft: "8px",
                  }}
                />
                پس از پرداخت حتما بلیت خود را دانلود نمایید
              </p>
            </div>
          </div>
        </InSetBoxShadow>
      </div>
    </div>
  );
};

export default Peyment;
